// import Main from '@/view/main'

export default {
  path: 'member',
  meta: {
    title: '会员管理'
  },
  component: () => import('@/components/parent-view'),
  // name: 'member',
  children: [
    {
      path: 'query',
      name: 'member-query',
      meta: {
        title: '会员查询',
        notCache: false
      },
      component: () => import('@/view/member/member-query')
    },
    {
      path: `detail/:memId/`,
      name: 'member-details',
      meta: {
        title: '会员详情',
        hideInTabBar: true
      },
      component: () => import('@/view/member/member-query/details.vue')
    },
    {
      path: 'org-query',
      name: 'org-list',
      meta: {
        title: '企业查询',
        notCache: false
      },
      component: () => import('@/view/member/org-query')
    },
    {
      path: `orgDetail/:orgId/`,
      name: 'org-details',
      meta: {
        title: '企业详情',
        hideInTabBar: true
      },
      component: () => import('@/view/member/org-query/details.vue')
    },
    {
      path: 'audit',
      name: 'cache-member-audit',
      meta: {
        title: '会员审核列表',
        notCache: false
      },
      component: () => import('@/view/member/member-audit')
    },
    {
      path: 'audit/org',
      name: 'member-org-audit',
      meta: {
        title: '企业审核',
        hideInTabBar: true
      },
      component: () => import('@/view/member/member-audit/organization.vue')
    },
    {
      path: 'audit/personal',
      name: 'member-personal-audit',
      meta: {
        title: '个人审核',
        hideInTabBar: true
      },
      component: () => import('@/view/member/member-audit/personal.vue')
    },
    {
      path: 'audit/teams',
      name: 'member-teams-audit',
      meta: {
        title: '班组审核',
        hideInTabBar: true
      },
      component: () => import('@/view/member/member-audit/teams.vue')
    },
    {
      path: 'audit/org/detail',
      name: 'member-org-audit-detail',
      meta: {
        title: '企业审核',
        hideInTabBar: true,
        isCheck: true
      },
      component: () => import('@/view/member/member-audit/organization.vue')
    },
    {
      path: 'audit/personal/detail',
      name: 'member-personal-audit-detail',
      meta: {
        title: '个人审核',
        hideInTabBar: true,
        isCheck: true
      },
      component: () => import('@/view/member/member-audit/personal.vue')
    },
    {
      path: 'audit/teams/detail',
      name: 'member-teams-audit-detail',
      meta: {
        title: '班组审核',
        hideInTabBar: true,
        isCheck: true
      },
      component: () => import('@/view/member/member-audit/teams.vue')
    },
    { // 建采通业务员审核 （TODO 将层级重构）
      path: 't',
      name: 'jiancai-tong-index',
      meta: {
        title: '建采通业务审核',
        notCache: false
      },
      component: () => import('@/view/member/jiancai-tong/index.vue')
    },
    {
      path: 't/:id',
      name: 'jiancai-tong-detail', // 建采通业务员审核详情
      meta: {
        title: '建采通业务审核',
        hideInTabBar: true
      },
      component: () => import('@/view/member/jiancai-tong/detail.vue')
    },
    {
      path: '',
      meta: {
        title: '充值审核'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: 'top_up',
          name: 'top-up-index',
          meta: {
            title: '充值审核',
            ignoreBreadCrumb: true,
            notCache: false
          },
          component: () => import('@/view/member/top-up-audit/index.vue')
        },
        {
          path: 'top_up/:code',
          name: 'top-up-detail', // 充值详情
          meta: {
            title: '充值详情',
            hideInTabBar: true
          },
          component: () => import('@/view/member/top-up-audit/detail.vue')
        },
        {
          path: 'top_up/audit/:code',
          name: 'top-up-detail',
          meta: {
            title: '审核详情',
            hideInTabBar: true
          },
          component: () => import('@/view/member/top-up-audit/detail.vue')
        }
      ]
    },
    {
      path: '',
      meta: {
        title: '提现审核'
      },
      component: () => import('@/components/parent-view'),
      children: [
        {
          path: 'withdraw',
          name: 'withdraw-index', // 提现审核
          meta: {
            title: '提现审核',
            ignoreBreadCrumb: true,
            notCache: false
          },
          component: () => import('@/view/member/withdraw-audit/index.vue')
        },
        {
          path: 'withdraw/audit/:code',
          name: 'top-up-detail',
          meta: {
            title: '审核详情',
            hideInTabBar: true
          },
          component: () => import('@/view/member/withdraw-audit/detail.vue')
        },
        {
          path: 'withdraw/:code',
          name: 'top-up-detail',
          meta: {
            title: '提现详情',
            hideInTabBar: true
          },
          component: () => import('@/view/member/withdraw-audit/detail.vue')
        }
      ]
    },
    {
      path: 'analyse',
      name: 'member-analyse',
      meta: {
        title: '会员分析'
      },
      component: () => import('@/view/member/analyse')
    },
    {
      path: 'enterprise',
      name: 'org-analyse',
      meta: {
        title: '企业分析'
      },
      component: () => import('@/view/member/enterprise-analyse')
    },
    {
      path: 'account/quit',
      name: 'cache-account-quit',
      meta: {
        title: '注销审核'
      },
      component: () => import('@/view/member/member-quit')
    },
    {
      path: 'account/quit/detail',
      name: 'cache-member-quit-detail',
      meta: {
        title: '注销审核详情'
      },
      component: () => import('@/view/member/member-quit/detail')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/member.js